/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Select_Group_Members_PromptInputs */



/**
* | output |
* | --- |
* | "Select a group to manage members" |
*
* @param {Team_Manager_Select_Group_Members_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_select_group_members_prompt = /** @type {((inputs?: Team_Manager_Select_Group_Members_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Select_Group_Members_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez un groupe pour gérer les membres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie eine Gruppe aus, deren Mitglieder Sie verwalten möchten.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona un gruppo per gestire i membri")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите группу для управления ее участниками.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione un grupo para administrar a los miembros")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择一个组来管理成员")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メンバーを管理するグループを選択してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सदस्यों को प्रबंधित करने के लिए एक समूह चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione um grupo para gerenciar os membros.")
	return /** @type {LocalizedString} */ ("Select a group to manage members")
});